/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Divider,
  FormControl, FormControlLabel, FormGroup,
  InputLabel, Radio, RadioGroup, Switch,
  TextField, Checkbox
} from '@material-ui/core'
import { useFormik } from 'formik'
import { settingFormValidation } from '../../../utils/validationSchema'
import { FormLoader } from '../../Loader/FormLoader'
import Settings from '@material-ui/icons/Settings'
import { Typography } from '../../Dashboard/Wrappers/Wrappers'
import { useStyles } from './Styles'

const SettingForm = ({ index, adminSectionType, setting, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const [value, setValue] = React.useState(setting.value)
  // const [checkValues, setCheckValues] = React.useState(setting.value)
  const settingForm = useFormik({
    initialValues: {
      value: setting.value
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: settingFormValidation([9].includes(setting.id) && adminSectionType === 'workspace', [10].includes(setting.id) && adminSectionType === 'workspace', [12, 13].includes(setting.id) && adminSectionType === 'workspace'),
    onSubmit: ((values, actions) => {
      onSubmit(setting.id, values, actions, setValue)
    })
  })

  const handleRadioChange = (event) => {
    settingForm.setFieldValue('value', event.target.value)
  }

  const handleCheckboxChange = (event, value) => {
    let newValue = settingForm.values.value || []
    if (!!event.target.checked) {
      newValue = [...newValue, value]
    } else {
      newValue = newValue.filter(item => item !== value)
    }
    settingForm.setFieldValue('value', newValue)
  }

  const expandAttr = () => ([6, 8, 11].includes(setting.id) && adminSectionType === 'workspace') ? { expanded: false } : {}
  return (
    <div className={classes.root}>
      <Accordion defaultExpanded={index === 0} {...expandAttr()} >
        <AccordionSummary
          expandIcon={<Settings/>}
          aria-controls="panel1c-content"
          id="panel1c-header"
        >
          <div className={classes.SettingHeader}>
            <Typography variant="h6">
              {setting.key}
            </Typography>
            <div className={classes.valueWrapper}>
              {([6, 8, 11].includes(setting.id) && adminSectionType === 'workspace') ?
                <>
                  <FormControlLabel
                    label={intl.formatMessage({ id: '1' === value.toString() ? 'UserNotice.Active' : 'UserNotice.inActive' })}
                    value={'1' === value.toString()}
                    control={<Switch color="primary" checked={'1' === value.toString()}
                                     value={'1' === value.toString()}/>}
                    onChange={(event) => {
                      settingForm.setSubmitting(true)
                      settingForm.setFieldValue('value', !!JSON.parse(event.target.value) ? '0' : '1')
                      onSubmit(setting.id, { value: !!JSON.parse(event.target.value) ? '0' : '1' }, settingForm, setValue)
                    }}
                  />
                  {settingForm.isSubmitting && <FormLoader size={60} loading={true}/>}
                </>
                :
                <Chip color={'primary'} label={([9].includes(setting.id) && adminSectionType === 'workspace')
                  ? <FormattedMessage id={`PaymentHeader.climeType.${value}`}/>
                  : ([10].includes(setting.id) && adminSectionType === 'workspace') ? value?.map(item => intl.formatMessage({ id: `eCommerceUIN.${item}` })).join(', ') : value
                }/>
              }
            </div>
          </div>
        </AccordionSummary>
        {!([6, 8, 11].includes(setting.id) && adminSectionType === 'workspace') &&
        <AccordionDetails className={classes.details}>
          <form onSubmit={settingForm.handleSubmit} noValidate autoComplete="off"
                className={classes.formWrapper}>

            {([10].includes(setting.id) && adminSectionType === 'workspace') ?
              <div className={classes.BasicInfoRow + ' auto'}>
                <FormControl variant="outlined" className='auto'>
                  <FormGroup row className={classes.radiosWrapper}
                             aria-label="Allowed Ecommerce UNI Types"
                             name="value">
                    <FormControlLabel className={'fixed'}
                                      control={<Checkbox color={'primary'}
                                                         checked={settingForm.values.value.includes('taxpayer')}
                                                         onChange={(event) => handleCheckboxChange(event, 'taxpayer')}/>}
                                      label={<FormattedMessage id='eCommerceUIN.taxpayer'/>}/>
                    <FormControlLabel className={'fixed'}
                                      control={<Checkbox color={'primary'}
                                                         checked={settingForm.values.value.includes('incentives')}
                                                         onChange={(event) => handleCheckboxChange(event, 'incentives')}/>}
                                      label={<FormattedMessage id='eCommerceUIN.incentives'/>}/>
                    <FormControlLabel className={'fixed'}
                                      control={<Checkbox color={'primary'}
                                                         checked={settingForm.values.value.includes('none-core')}
                                                         onChange={(event) => handleCheckboxChange(event, 'none-core')}/>}
                                      label={<FormattedMessage id='eCommerceUIN.none-core'/>}/>
                  </FormGroup>
                </FormControl>
              </div>
              : (([9].includes(setting.id) && adminSectionType === 'workspace')
                ? <div className={classes.BasicInfoRow}>
                  <FormControl variant="outlined">
                    <RadioGroup className={classes.radiosWrapper} aria-label="AllowedTaxTypes" name="allowed_taxes"
                                value={settingForm.values.value}
                                onChange={handleRadioChange}>
                      <FormControlLabel value="income" control={<Radio color={'primary'}/>}
                                        label={<FormattedMessage id='PaymentHeader.climeType.income'/>}/>
                      <FormControlLabel value="vat" control={<Radio color={'primary'}/>}
                                        label={<FormattedMessage id='PaymentHeader.climeType.vat'/>}/>
                    </RadioGroup>
                  </FormControl>
                </div>
                : ([12, 13].includes(setting.id) && adminSectionType === 'workspace')
                  ? <div className={classes.BasicInfoRow}>
                    <InputLabel id="Setting.value"> {<FormattedMessage id='Fields.label.value'/>} </InputLabel>
                    <FormControl variant="outlined">
                      <TextField
                        placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.value' })}
                        id="Setting.value"
                        type={'text'}
                        margin="dense"
                        variant="outlined"
                        name='value'
                        value={settingForm.values.value}
                        onChange={settingForm.handleChange}
                        onBlur={settingForm.handleBlur}
                        helperText={settingForm.errors.value && settingForm.touched.value && settingForm.errors.value}
                        error={settingForm.errors.value && settingForm.touched.value !== undefined}
                      />
                    </FormControl>
                  </div>
                  : <div className={classes.BasicInfoRow}>
                    <InputLabel id="Setting.value"> {<FormattedMessage id='Fields.label.value'/>} </InputLabel>
                    <FormControl variant="outlined">
                      <TextField
                        placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.value' })}
                        id="Setting.value"
                        type={'number'}
                        margin="dense"
                        variant="outlined"
                        name='value'
                        value={settingForm.values.value}
                        onChange={settingForm.handleChange}
                        onBlur={settingForm.handleBlur}
                        helperText={settingForm.errors.value && settingForm.touched.value && settingForm.errors.value}
                        error={settingForm.errors.value && settingForm.touched.value !== undefined}
                      />
                    </FormControl>
                  </div>)
            }
            <button type="submit" disabled={settingForm.isSubmitting || !settingForm.isValid}
                    className={classes.AddAdminSubmit}>
              <FormattedMessage id='AdditionalInfo.button.submit'/>
            </button>
            {settingForm.isSubmitting && <FormLoader loading={true}/>}
          </form>
        </AccordionDetails>
        }
        <Divider/>
      </Accordion>
    </div>
  )
}

export default SettingForm
